
import reducers from './reducers';
import saga from './effects';

export function getAppModule() {
	return {
		id: 'app-module',
		reducerMap: {
			app: reducers,
		},
		sagas: [saga]
	}
}
